import { Routes } from "@angular/router";
import { AuthGuard, PlayerGuard, ContentGuard } from "src/app/services";
import { MarketplaceAdminGuard } from "./pages/admin/admin.guard";
import { marketplaceAdminRoutes } from "./pages/admin/pages/marketplace-admin.routes";

export const marketplaceRoutes: Routes = [
    {
        path: '',
        redirectTo: 'products',
        pathMatch: 'full',
    },
    {
        path: 'basket',
        loadComponent: () => import('./pages/basket/basket.component').then(c => c.BasketComponent),
        canActivate: [AuthGuard, PlayerGuard, ContentGuard],
    },
    {
        path: 'tickets',
        loadComponent: () => import('./pages/tickets/tickets.component').then(c => c.TicketsComponent),
        canActivate: [AuthGuard, PlayerGuard, ContentGuard],
    },
    {
        path: 'products',
        loadComponent: () => import('./pages/products/products.component').then(c => c.ProductsComponent),
        canActivate: [AuthGuard, PlayerGuard, ContentGuard],
    },
    {
        path: 'products/:slug',
        loadComponent: () => import('./pages/product-details/product-details.component').then(c => c.ProductDetailsComponent),
        canActivate: [AuthGuard, PlayerGuard, ContentGuard],
    },
    {
        path: 'admin',
        loadComponent: () => import('./pages/admin/admin.component').then(c => c.MarketPlaceAdminComponent),
        canActivate: [AuthGuard, PlayerGuard, ContentGuard, MarketplaceAdminGuard],
        children: marketplaceAdminRoutes,
    },
]
